import { LuUser } from "react-icons/lu"
import { useLocation, useNavigate } from "react-router-dom"

import { useGlobalSearch } from "@fuse/sharedComponents/globalSearchContext"
import { logoText } from "@fuse/sharedComponents/legacyUI/Top/styles"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { EFeatureFlags, TWebUser } from "@letshang/constants"
import { get } from "lodash-es"
import { useRecoilState } from "recoil"
import { ROUTES } from "src/App"

import { userState } from "@fuse/recoil/signup"

import { useProcessFeatureFlags } from "@settingsAlias/featureFlags"

import { splitFullName } from "@fuse/utils/DeviceDection"

import { Colors } from "@fuse/styles/color"

import IconExplore from "@fuse/assets/images/Profile/img-icon-explore.svg"
import IconFillExplore from "@fuse/assets/images/Profile/img-icon-fill-explore.svg"
import IconFillHome from "@fuse/assets/images/Profile/img-icon-fill-home.svg"
import IconFillPeople from "@fuse/assets/images/Profile/img-icon-fill-people.svg"
import IconFillSearch from "@fuse/assets/images/Profile/img-icon-fill-search.svg"
import IconHome from "@fuse/assets/images/Profile/img-icon-home.svg"
import IconPeople from "@fuse/assets/images/Profile/img-icon-people.svg"
import IconSearch from "@fuse/assets/images/Profile/img-icon-search.svg"

const FancyLetsHang = () => {
  const navigate = useNavigate()

  const onLandingPage = () => {
    navigate(ROUTES.LANDING)
  }

  return (
    <FancyText
      className="text-xl md:text-2xl cursor-pointer text-nowrap"
      style={logoText}
      onClick={onLandingPage}
    >
      Let’s Hang!
    </FancyText>
  )
}

const FancyPeopleLabel = () => {
  const navigate = useNavigate()

  const onLandingPage = () => {
    navigate(ROUTES.LANDING)
  }

  const handleProfileClick = () => {
    navigate(ROUTES.PROFILE)
  }

  return (
    <div style={logoText}>
      <FancyText
        className="text-xl md:text-2xl cursor-pointer text-nowrap"
        onClick={handleProfileClick}
      >
        People
      </FancyText>
      <FancyText
        className="hidden md:block cursor-pointer"
        onClick={onLandingPage}
      >
        Let’s Hang!
      </FancyText>
    </div>
  )
}

const FancyExploreLabel = () => {
  const navigate = useNavigate()

  const onLandingPage = () => {
    navigate(ROUTES.EXPLORE)
  }

  return (
    <FancyText
      className="text-xl md:text-2xl cursor-pointer text-nowrap"
      style={logoText}
      onClick={onLandingPage}
    >
      Explore
    </FancyText>
  )
}

interface NavbarProps {
  className?: string
}

const Navbar: React.FC<NavbarProps> = ({ className = "" }) => {
  const [user, setUser] = useRecoilState(userState)
  const isBuddiesEnabled = useProcessFeatureFlags(EFeatureFlags.BUDDIES_SECTION)

  const navigate = useNavigate()
  const location = useLocation()
  const { showSearchModal } = useGlobalSearch()

  const handleProfileClick = () => {
    navigate(ROUTES.PROFILE)
  }

  const NavbarScreens = [
    {
      label: "Home",
      icon: IconHome,
      iconFill: IconFillHome,
      onPress: () => navigate(ROUTES.LANDING),
      isFocused: location.pathname === ROUTES.LANDING,
    },
    {
      label: "People",
      icon: IconPeople,
      iconFill: IconFillPeople,
      onPress: () => navigate(ROUTES.PEOPLE),
      isFocused: location.pathname === ROUTES.PEOPLE,
    },
    {
      label: "Explore",
      icon: IconExplore,
      iconFill: IconFillExplore,
      onPress: () => navigate(ROUTES.EXPLORE),
      isFocused: location.pathname === ROUTES.EXPLORE,
    },

    {
      label: "Search",
      icon: IconSearch,
      iconFill: IconFillSearch,
      onPress: () => showSearchModal(),
      isFocused: location.pathname === ROUTES.SEARCH,
    },
  ]

  const handleSignupClick = () => {
    navigate(ROUTES.SIGNUP)
    setUser((prevUser: TWebUser) => ({
      ...prevUser,
      redirectUrl: `${location.pathname}${location.search}`,
    }))
  }

  const isPeopleSection = location.pathname === ROUTES.PEOPLE
  const isExploreSection = location.pathname === ROUTES.EXPLORE

  return (
    <>
      <div className={`w-full relative z-[100] ${className}`}>
        <header className="px-4 md:px-8 py-4 lg:px-12 xl:px-16 2xl:px-24  px-auto flex justify-between  gap-4 ">
          <div className=" flex md:hidden  items-center">
            {isPeopleSection ? (
              <FancyPeopleLabel />
            ) : isExploreSection ? (
              <FancyExploreLabel />
            ) : (
              <FancyLetsHang />
            )}
          </div>

          <div className=" hidden md:flex items-center">
            <FancyLetsHang />
          </div>
          <div className="flex gap-4 md:gap-6  flex-1 ">
            {isBuddiesEnabled && (
              <>
                {NavbarScreens?.map((item, index) => {
                  const isFocused = get(item, "isFocused", false)
                  return (
                    <div
                      key={index.toString()}
                      onClick={() => item?.onPress()}
                      className={`flex  text-md items-center justify-center cursor-pointer ${isFocused ? "text-white" : "text-white35"}`}
                    >
                      <img
                        className="block md:hidden h-6 max-w-6"
                        src={isFocused ? item?.iconFill : item?.icon}
                        alt={item?.label}
                      />
                      <p className="hidden md:block">{item?.label}</p>
                    </div>
                  )
                })}
              </>
            )}
          </div>

          <div className="flex max-md:justify-end max-md:w-full">
            {user.isLoggedIn ? (
              <div
                className="flex gap-4 cursor-pointer"
                onClick={() => {
                  handleProfileClick()
                }}
              >
                <div className="bg-gray-400 relative h-10 md:h-12 aspect-auto-[1] rounded-lg overflow-hidden flex items-center justify-center">
                  {user?.avatarUrl ? (
                    <img
                      src={user?.avatarUrl}
                      alt="profile"
                      className="w-full h-full"
                    />
                  ) : (
                    <LuUser color={Colors.white} />
                  )}
                </div>

                <div className="hidden text-white flex-col sm:flex">
                  <p className="text-left">Hey,</p>

                  <p className="text-1.5xl font-medium capitalize">
                    {splitFullName(user?.displayName || user?.name)
                      ?.firstName || user?.firstName}
                  </p>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  handleSignupClick()
                }}
                className="px-4 md:px-6 py-2 bg-gray-700 rounded-full hover:bg-gray-60 blurTypeLight border border-white/20 ring-1 ring-gray-900/5 text-white text-xs sm:text-sm md:text-base text-nowrap"
              >
                Sign in
              </button>
            )}
          </div>
        </header>
      </div>
    </>
  )
}

export default Navbar
